import React, { useContext } from 'react'
import { UserContext } from '../../wrappers/UserContext'
import { hasAccessToAdmin } from '../../../utils/user/permissions'
import AdminLink from '../landing-page/AdminLink'
import ManageUsersButton from './ManageUsersButton'
import RemainingLoginTime from '../../../utils/user/RemainingLoginTime'

const LogoutButton = () => {
    const { client, user, roles } = useContext(UserContext)
    return (
        <>
            {user && <RemainingLoginTime />}
            {/* {hasAccessToAdmin(roles) ? <AdminLink /> : null}
            {hasAccessToAdmin(roles) ? <ManageUsersButton /> : null} */}
            {user && (
                <div className="userControls">
                    <div
                        className="button is-light is-small"
                        onClick={function () {
                            client.signoutRedirect()
                        }}
                    >
                        Logout
                    </div>
                </div>
            )}
        </>
    )
}

export default LogoutButton
